import axios from 'axios';
import {API} from '../../api/api';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {parseJwt_Expired} from '../../helper/parseJwtExpired';

export const availableAssaysAction = createAsyncThunk(
    'availableAssaysAction',
    async function (body) {
        try {
            const access_token_toxometris = localStorage.getItem('access_token_toxometris');
            access_token_toxometris && parseJwt_Expired(access_token_toxometris);

            const config = {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_token_toxometris}`,
                    'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
                }
            }
            const response = await axios.post(`${API.BASE_URL}/get_available_assays`,body, config);
            return response.data
        } catch (e) {
            return {message:e?.message || 'Something wnt wrong, please try later'}
        }
    })

const availableAssaysSlice = createSlice({
    name: 'AVAILABLE_ASSAYS_TOOLKIT',
    initialState: {
        loading: null,
        availableAssaysResult: [],
        error: null,
        status: null
    },
    reducers: {},
    extraReducers: {
        [availableAssaysAction.pending]: (state) => {
            state.status = 'AVAILABLE_ASSAYS_REQUEST';
            state.error = null;
            state.loading = true;
        },

        [availableAssaysAction.fulfilled]: (state, action) => {
            state.status = 'AVAILABLE_ASSAYS_SUCCESS';
            state.availableAssaysResult = action.payload;
            state.loading = false;
            state.error = null;
        },

        [availableAssaysAction.rejected]: (state, action) => {
            state.status = 'AVAILABLE_ASSAYS_FAIL';
            state.loading = false;
            state.error = action.payload || {message: 'ERROR !!!'};
        },
    }
})

export default availableAssaysSlice.reducer;
// export const {logoutAction, emptyData} = loginSlice.actions;
